module.exports = __webpack_public_path__ + "static/media/right.e6ed2268.svg";